import React, { useState, useCallback, useEffect, Fragment } from 'react'
import { Formik, Form } from 'formik'
import { useSelector } from 'react-redux'
import InputError from '../../../components/InputError/InputError'
import DashboardService from '../../../services/dashboard.service'
import { accountsSelector } from '../../../selectors'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import NeoInput from '../../../components/NeoInput/NeoInput'
import { useTranslation } from 'react-i18next'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import NeoButton from '../../../components/NeoButton/NeoButton'
import { NeoLoader } from '../../../components/FormComponents'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import { AddAccountSchema } from '../../../schemas/account'

import validationConfig from 'custom/config/validation.config.json'
import { ACCOUNT_CARD_KEYS, SIDENAV_KEYS } from '../../../utils/translation-constants'
const openAccountConfig = validationConfig['openAccount']

export default function AddNewAccount() {
  const [loading, setLoading] = useState(false)
  const [accountClassList, setAccountClassList] = useState({})
  const [stage, setStage] = useState(0)
  const [otpEnable, setOtpEnable] = useState(false)
  const [otp, setOtp] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const accountList = useSelector(accountsSelector) || []
  const [formData, setFormData] = useState({})
  const history = useHistory()
  const { t } = useTranslation()

  const getAccountClasses = useCallback(async () => {
    try {
      const response = await DashboardService.getAccountClass()
      if (response.status === 200) {
        setAccountClassList(response.data['accountClasses'])
        setStage(1)
      }
    } catch (err) {}
  })

  const handleAccountVerify = useCallback(
    async (data) => {
      try {
        const account = accountList.filter((v) => v.accountNo === data.accountNumber)[0]
        const accClass = accountClassList.find((e)=>e.description===data.accClassName)
        const req = {
          accClass: accClass.accountClass,
          accountType: account.accountType,
          brnCode: account.brnCode,
          currency: account.currency,
          srcAccount: account.accountNo,
          srcBranch: account.brnCode,
        }
        setFormData({ ...req, accClassName: data.accClassName })
        const response = await DashboardService.createCASAAccountVerify(req)

        if (response.status === 200) {
          setOtpEnable(response.data['otpEnable'])
          setStage(2)
        }
      } catch (err) {}
    },
    [accountList, accountClassList],
  )

  const handleAccountConfirm = useCallback(async () => {
    try {
     
      setLoading(true)
      const response = await DashboardService.createCASAAccountConfirm({
        otpNo: otp,
        ...formData,
      })

      if (response.status === 200) {
        setSuccessMessage(`${response.data['message']} - ${response.data['accountNo']}`)
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setOtp('')
      setLoading(false)
    }
  }, [otp, formData])

  useEffect(() => {
    getAccountClasses()
  }, [])

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>{t(ACCOUNT_CARD_KEYS.OPEN_ACCOUNT)}</div>

        <Formik
          initialValues={{
            accountNumber: '',
            accClassName: '',
          }}
          validationSchema={AddAccountSchema}
          onSubmit={handleAccountVerify}>
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='1'
                    showAsterisk={openAccountConfig['isAccountClassRequired']}
                    mode='select'
                    text={t(ACCOUNT_CARD_KEYS.ACCOUNT_CLASS)}
                    name='accClassName'
                    onChange={(e) => {
                      handleChange(e)
                    }}
                    keyValue='description'
                    list={accountClassList}
                  />
                  <InputError text={errors.accClassName} touched={touched.accClassName} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='2'
                    showAsterisk={openAccountConfig['isAccountNoRequired']}
                    mode='select'
                    text={t(ACCOUNT_CARD_KEYS.FUNDING_ACC_NO)}
                    name='accountNumber'
                    onChange={handleChange}
                    list={accountList}
                    keyValue='accountNo'
                  />
                  <InputError text={errors.accountNumber} touched={touched.accountNumber} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  {isSubmitting ? (
                    <NeoLoader />
                  ) : (
                    <NeoButton
                      tabIndex='3'
                      type='submit'
                      disabled={isSubmitting}
                      className='btn btn-neo'
                      mode='newDesign'
                      text={t(SIDENAV_KEYS.TOUCH_ID_KEYS.SUBMIT)}
                    />
                  )}
                </div>
              </div>
              <div className='back-cancel-btn-container'>
              <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'4'} onClick={() => history.push('/dashboard')}>
                {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(ACCOUNT_CARD_KEYS.CONFIRM_ACC_DETAILS)}</h3>
        <div>
          <h6 className='label'>{t(ACCOUNT_CARD_KEYS.FUNDING_ACC_NO)}</h6>
          <h6 className='value'>{formData.srcAccount}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ACCOUNT_CARD_KEYS.ACCOUNT_CLASS)}</h6>
          <h6 className='value'>{formData.accClassName}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ACCOUNT_CARD_KEYS.BRANCH_CODE)}</h6>
          <h6 className='value'>{formData.brnCode}</h6>
        </div>
 
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              type='button'
              className='btn btn-neo'
              mode='newDesign'
              onClick={() => (otpEnable ? setStage(3) : handleAccountConfirm())}
              text={t(SIDENAV_KEYS.TOUCH_ID_KEYS.CONFIRM)}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  function renderSwitch() {
    switch (stage) {
      case 0:
        return <NeoLoader />
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP loading={loading} otp={otp} setOTP={setOtp} onSubmit={handleAccountConfirm} />
        )
      case 4:
        return <NeoSuccess message={successMessage} linkPath='/dashboard' />
      default:
        return <NeoLoader />
    }
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='ADD_ACCOUNT'
      keyPath={'ADD_ACCOUNT'}
      showEmptySpace={true}>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithOutAccountCard>
  )
}
